const axios = require('axios')
const requestInstance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  headers: {
    Authorization: ''
  },
})

export default requestInstance
